import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fileHTXStudentPresentation from '../../assets/files/htx-elev-praesentation.pptx';
import fileHTXFacilitatorGuide from '../../assets/files/htx-facilitator-guide.pdf';
import fileHHXStudentPresentation from '../../assets/files/hhx-elev-praesentation.pptx';
import fileHHXFacilitatorGuide from '../../assets/files/hhx-facilitator-guide.pdf';
import fileSTXStudentPresentation from '../../assets/files/stx-elev-praesentation.pptx';
import fileSTXFacilitatorGuide from '../../assets/files/stx-facilitator-guide.pdf';
import fileHFStudentPresentation from '../../assets/files/hf-elev-praesentation.pptx';
import fileEUDEUXStudentPresentation from '../../assets/files/eudeux-elev-praesentation.pptx';
import fileSupportAndExtra from '../../assets/files/support-og-tilvalg.pdf';
import {getSchoolStats} from 'helpers/stats-helper';
import {sortArrayByProperty} from 'helpers/array-helper';
import {loginUiTexts, schoolUiTexts} from 'data/ui-texts';
import Button from 'components/ui/button/button';
import Logo from '../ui/logo/logo';
import Logos from 'components/ui/logos/logos';
import PopupVideo from './popup-video/popup-video';
import PopupCreateGame from './popup-create-game/popup-create-game';
import PopupDeleteGame from './popup-delete-game/popup-delete-game';
import './landing-page-school.scss';

const LandingPageSchool = (
	{
		scenarioId, 
		loadingGameId,
		games, 
		schoolData, 
		goToGame,
		createGame,
		deleteGame, 
		handleLogout, 
		updateBackground 
	}
) => {
	/* Video popup */
	const [showVideoPopup, setShowVideoPopup] = useState(false);

	/* Create game popup */
	const [showPopupCreateGame, setShowPopupCreateGame] = useState(false);

	/* Delete game popup */
	const [deleteGameId, setDeleteGameId] = useState(null);

	/* Stats */
	const {playthroughCount, studentCount} = getSchoolStats(schoolData, games);

	const sortedGames = games ? sortArrayByProperty(games, 'created', 'DESC') : [];

	let surveyLink = null;
	if (schoolData.facilitatorSurveyLink) {
		surveyLink = schoolData.facilitatorSurveyLink;
		if (surveyLink.indexOf('http://') === 0) {
			surveyLink = surveyLink.replace('http://', 'https://');
		}
		if (surveyLink.indexOf('https://') !== 0) {
			surveyLink = 'https://' + surveyLink;	
		}
	}

	const questionRoundLink = 'https://da.surveymonkey.com/r/sporgsmaal';
	const questionaireLink = 'https://da.surveymonkey.com/r/gymnasiespilskema';
	const feedbackLink = 'https://da.surveymonkey.com/r/spilfeedback';

	useEffect(() => {
		// Set background image id
		updateBackground('login', scenarioId);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	let file1 = null;
	let file2 = null;
	let file3 = fileSupportAndExtra;
	let file1name = schoolUiTexts.studentPresentation;
	let file2name = schoolUiTexts.facilitatorGuide;
	let file3name = schoolUiTexts.supportAndExtra;
	let file1button = schoolUiTexts.studentPresentation;
	let file2button = schoolUiTexts.facilitatorGuide;
	let file3button = schoolUiTexts.supportAndExtra;
	if (scenarioId === 'game1') {
		file1 = fileHTXStudentPresentation;
		file1name += '-htx';
		file2 = fileHTXFacilitatorGuide;
		file2name += '-htx';
	} else if (scenarioId === 'game2') {
		file1 = fileHHXStudentPresentation;
		file1name += '-hhx';
		file2 = fileHHXFacilitatorGuide;
		file2name += '-hhx';
	} else if (scenarioId === 'game3') {
		file1 = fileSTXStudentPresentation;
		file1name += '-stx';
		file2 = fileSTXFacilitatorGuide;
		file2name += '-stx';
	} else if (scenarioId === 'game4') {
		file1 = fileHFStudentPresentation;
		file1name += '-hf';
		// file2 = fileHFFacilitatorGuide; // TODO
	} else if (scenarioId === 'game5') {
		file1 = fileEUDEUXStudentPresentation;
		file1name += '-eudeux';
		// file2 = fileHHXFacilitatorGuide; // TODO
	}

	return (
		<div className={'LandingPageSchool'}>
			<Logos />
			<div className='LandingPageSchool-logoWrapper'>
				<Logo scenarioId={scenarioId} page="landing" />
			</div>
			<div className="LandingPageSchool-content">
				<div className='LandingPageSchool-schoolName'>
					<span>{schoolData.name}</span>
				</div>
				<div className='LandingPageSchool-schoolStats'>
					<div className='LandingPageSchool-studentCount'>
						<span>{schoolUiTexts.landingPage.studentsField} {studentCount}</span>
					</div>
					<span>
						{'|'}
					</span>
					<div className='LandingPageSchool-playthroughCount'>
						<span>{schoolUiTexts.landingPage.playThroughField} {playthroughCount}</span>
					</div>
				</div>

				<div className='LandingPageSchool-createGameButton'>
					<Button
						classes={['login', scenarioId]}
						text={schoolUiTexts.landingPage.createGame}
						onClick={() => {setShowPopupCreateGame(true);}}
					/>
				</div>

				{/* Games */}
				<div className='LandingPageSchool-games'>
					<div className={'LandingPageSchool-row header ' + scenarioId}>
						<div className='LandingPageSchool-cell'>
							<span>{schoolUiTexts.landingPage.game}</span>
						</div>
						<div className='LandingPageSchool-cell'>
							<span>{schoolUiTexts.landingPage.gameCode}</span>
						</div>
						<div className='LandingPageSchool-cell center'>
							<span>{schoolUiTexts.landingPage.choose}</span>
						</div>
						<div className='LandingPageSchool-cell center delete'>
							<span>{schoolUiTexts.landingPage.delete}</span><span></span>
						</div>
					</div>

					<div className="LandingPageSchool-gamesWrap">
						{sortedGames && sortedGames.map((game, index) => {
					
							return (
								<div key={index} className='LandingPageSchool-row body'>
									<div className='LandingPageSchool-cell'>
										<span>{game.name}</span>
									</div>
									<div className='LandingPageSchool-cell'>
										<span>{game.id}</span>
									</div>
									<div className='LandingPageSchool-cell'>
										<Button
											isLoading={loadingGameId === game.id}
											classes={['flatBlueLight', scenarioId]}
											text={schoolUiTexts.landingPage.goToGame}
											onClick={() => {goToGame(game.id);}}
										/>
									</div>
									<div 
										className="LandingPageSchool-cell delete" 
										onClick={() => {setDeleteGameId(game.id);}}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>

			<div className='LandingPageSchool-buttonsWrapper'>
				<div className="LandingPageSchool-subtitle">
					<span>{schoolUiTexts.controlPanel}</span>
				</div>
				{/* Download */}
				{(file1 || file2 || file3) && <div className="LandingPageSchool-buttonsSection">
					<div className="LandingPageSchool-buttonsSectionTitle">
						<span>{schoolUiTexts.download}</span>
					</div>
					{file1 &&
						<div className="LandingPageSchool-manualBtn">
							<Button 
								type={'a'}
								href={file1}
								text={file1button}
								fileName={file1name}
								classes={['fullWidth', 'login', 'download', scenarioId]}
							/>
						</div>
					}
					{file2 &&
						<div className="LandingPageSchool-manualBtn">
							<Button 
								type={'a'}
								href={file2}
								text={file2button}
								fileName={file2name}
								classes={['fullWidth', 'login', 'download', scenarioId]}
							/>
						</div>
					}
					{file3 &&
						<div className="LandingPageSchool-manualBtn">
							<Button 
								type={'a'}
								href={file3}
								text={file3button}
								fileName={file3name}
								classes={['fullWidth', 'login', 'download', scenarioId]}
							/>
						</div>
					}
				</div>}

				{/* Survey answers */}
				{surveyLink && <div className="LandingPageSchool-buttonsSection">
					<div className="LandingPageSchool-buttonsSectionTitle">
						<span>{schoolUiTexts.viewSurveys}</span>
					</div>
					<div className="LandingPageSchool-surveyBtn">
						<Button 
							type={'a'}
							href={surveyLink}
							text={schoolUiTexts.surveyLink2}
							fileName={null}
							classes={['fullWidth', 'login', scenarioId]}
						/>
					</div>
				</div>}

				{/* Edit content */}
				<div className="LandingPageSchool-buttonsSection">
					<div className="LandingPageSchool-buttonsSectionTitle">
						<span>{schoolUiTexts.editContent}</span>
					</div>
					<div className="LandingPageSchool-editQuestionRoundBtn">
						<Button 
							type={'a'}
							href={questionRoundLink}
							text={schoolUiTexts.editQuestionRound}
							fileName={null}
							classes={['fullWidth', 'login', scenarioId]}
						/>
					</div>
					<div className="LandingPageSchool-editQuestionaireBtn">
						<Button 
							type={'a'}
							href={questionaireLink}
							text={schoolUiTexts.editQuestionaire}
							fileName={null}
							classes={['fullWidth', 'login', scenarioId]}
						/>
					</div>
					<div className="LandingPageSchool-feedbackBtn">
						<Button 
							type={'a'}
							href={feedbackLink}
							text={schoolUiTexts.otherFeedback}
							fileName={null}
							classes={['fullWidth', 'login', scenarioId]}
						/>
					</div>
				</div>

				{/* Try games */}
				{(schoolData.showLinkToShortHTX || schoolData.showLinkToShortHHX) && 
				<div className="LandingPageSchool-buttonsSection">
					<div className="LandingPageSchool-buttonsSectionTitle">
						<span>{schoolUiTexts.tryGames}</span>
					</div>
					{schoolData.showLinkToShortHTX && <div className="LandingPageSchool-shortGameBtn">
						<Button 
							type={'a'}
							href={'https://kort.elevspil.dk/htx'}
							text={schoolUiTexts.linkToShortHTX}
							fileName={null}
							classes={['fullWidth', 'login', scenarioId]}
						/>
					</div>}
					{schoolData.showLinkToShortHHX && <div className="LandingPageSchool-shortGameBtn">
						<Button 
							type={'a'}
							href={'https://kort.elevspil.dk/hhx'}
							text={schoolUiTexts.linkToShortHHX}
							fileName={null}
							classes={['fullWidth', 'login', scenarioId]}
						/>
					</div>}
				</div>}
			</div>

			{/* Logout button */}
			<div className="LandingPageSchool-logoutBtn">
				<Button 
					classes={['fullWidth', 'blueLight', 'logout-2', scenarioId]} 
					text={loginUiTexts.logout}
					onClick={() => {handleLogout();}}
				/>
			</div>

			{/* Back to select game btn */}
			<div className="LandingPageSchool-backBtn">
				<Button 
					classes={['backBtnGame', scenarioId]} 
					text={schoolUiTexts.back}
					type="a"
					href="/"
					target="_self"
				/>
			</div>

			{/* Video popup */}
			{showVideoPopup && <PopupVideo closePopup={() => {setShowVideoPopup(false);}}/>}

			{/* Create Game Popup */}
			{showPopupCreateGame &&
				<PopupCreateGame
					scenarioId={scenarioId}
					createGame={createGame}
					closePopup={() => {setShowPopupCreateGame(false);}}
				/>
			}

			{deleteGameId && 
				<PopupDeleteGame 
					scenarioId={scenarioId}
					gameId={deleteGameId}
					games={games}
					deleteGame={deleteGame}
					closePopup={() => {setDeleteGameId(null);}}
				/>}
		</div>
	);
};

LandingPageSchool.propTypes = {
	scenarioId: PropTypes.string.isRequired,
	loadingGameId: PropTypes.string,
	games: PropTypes.array.isRequired,
	schoolData: PropTypes.object.isRequired,
	goToGame: PropTypes.func.isRequired,
	createGame: PropTypes.func.isRequired,
	deleteGame: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired
};

export default LandingPageSchool;
